import { faLongArrowAltRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";

export default function ConfirmStakeModal({ show, hide, confirm, stake }) {
    const configs = useSelector(state => state.config);

    return (
        <>
            <Modal show={show} onHide={hide} size='lg'>
                <Modal.Body className="confirm-stake-modal">
                    <div className='stake-header text-center'>
                        <h3>
                            Confirm Staking
                        </h3>
                    </div>
                    <div className="confirm-stake-text" style={{ fontWeight: "500"}}>
                        <div className="col-12 text-center">
                            You're about to stake your QUDO tokens.
                        </div>
                    </div>

                    <div className="confirm-stake-stake text-center">
                        {stake ? stake : 0 } <span>QUDO</span>
                    </div>

                    <div className="confirm-stake-text text-center">
                        <div className="confirm-stake-bold">
                            Please note:
                        </div>
                        <div className="confirm-stake-info">
                            Once staked, your tokens will be locked for a minimum 
                            of {configs.stake_lock_time_days} days.
                            You won't be able to withdraw or transfer them during this period.
                        </div>
                        <a className="confirm-stake-link" href="https://qudo.io/how-it-works#staking-rewards" target="_blank">
                            Learn more about staking rewards and benefits <FontAwesomeIcon icon={faLongArrowAltRight} />
                        </a>
                    </div>

                    <div className="confirm-stake-btns">
                        <div className="cancel" onClick={hide}>
                            Cancel
                        </div>
                        <div className="confirm" onClick={confirm}>
                            Confirm
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
